import { Column } from 'primereact/column'
import { DataTable } from 'primereact/datatable'
import React, { useEffect, useState } from 'react'
import { FaRegTrashAlt } from 'react-icons/fa'
import { connect } from 'react-redux'

import { Btn, BtnIcon, CustomCheckbox, CustomModal, HorizontalSpacer, InputText } from '../../../../../components'
import * as ProdutoHttp from '../../../../../services/api/https/registration/produto.http'
import { urlCodigoBarrasEans } from '../../../../../services/api/routes/registration.routes'
import { formatIsoDateToLocale } from '../../../../../services/util/date.service'
import { errorHandler } from '../../../../../services/util/error.service'
import {
  hideLoadingBox,
  showLoadingBox,
  showMessageBox,
} from '../../../../../store/actions/system.actions'
import './ModalEan.css'

const LOAD_MESSAGE = {
  NONE: 'NONE',
  GET: 'Adquirindo EANs',
  SAVE: 'Salvando EAN',
  DELETE: 'Deletando EAN',
  SUCCESS: 'EAN salvo com sucesso',
}

const INITIAL_STATE = {
  id: 0,
  product_code: '',
  name: '',
  codigoBarra: { ean: '', product_id: '', qte_caixa: '', packaging_type: '' },
  eans: [],
  savedEan: {},
  selectedEan: {},
  loadingMessage: LOAD_MESSAGE.NONE,
  errorMessage: null,
  selecionarTodos: false,
}

function ModalEan({ dispatch, show, data, onModalClose }) {
  const [state, setState] = useState({ ...INITIAL_STATE })

  useEffect(() => {
    if (show) onInit(data)
  }, [show])

  useEffect(() => {
    switch (state.loadingMessage) {
      case LOAD_MESSAGE.NONE:
        dispatch(hideLoadingBox())
        break

      case LOAD_MESSAGE.GET:
        dispatch(showLoadingBox('Aguarde...', state.loadingMessage))
        getEans(state.id)
        break

      case LOAD_MESSAGE.SAVE:
        dispatch(showLoadingBox('Aguarde...', state.loadingMessage))
        salvarEan(state.codigoBarra)
        break

      case LOAD_MESSAGE.DELETE:
        dispatch(showLoadingBox('Aguarde...', state.loadingMessage))
        deleteEan(state.selectedEan.id)
        break

      case LOAD_MESSAGE.SUCCESS:
        dispatch(hideLoadingBox())
        dispatch(showMessageBox(state.loadingMessage, null))
        break

      default:
        break
    }
  }, [state.loadingMessage])

  useEffect(() => {
    if (state.errorMessage) {
      dispatch(showMessageBox(null, state.errorMessage))
      setState(prevState => ({
        ...prevState,
        loadingMessage: LOAD_MESSAGE.NONE,
        errorMessage: null,
      }))
    }
  }, [state.errorMessage])

  const salvarEan = codigoBarra => {
    ProdutoHttp.salvarEan(
      codigoBarra.ean,
      codigoBarra.product_id,
      codigoBarra.qte_caixa,
      codigoBarra.packaging_type,
    )
      .then(savedEan =>
        setState(prevState => {
          const { eans } = prevState
          eans.push(savedEan)
          prevState['eans'] = eans
          prevState['codigoBarra'] = {
            ean: '',
            product_id: savedEan.productId,
            qte_caixa: '',
            packaging_type: '',
          }
          return { ...prevState, loadingMessage: LOAD_MESSAGE.SUCCESS }
        }),
      )
      .catch(err =>
        setState(prevState => ({
          ...prevState,
          errorMessage: errorHandler(err),
          loadingMessage: LOAD_MESSAGE.NONE,
        })),
      )
  }

  const deleteEan = eanID => {
    ProdutoHttp.deleteEan(eanID)
      .then(() =>
        setState(prevState => {
          const { eans } = prevState
          prevState['eans'] = eans.filter(e => e.id !== eanID)
          return { ...prevState, loadingMessage: LOAD_MESSAGE.SUCCESS }
        }),
      )
      .catch(err =>
        setState(prevState => ({
          ...prevState,
          errorMessage: errorHandler(err),
          loadingMessage: LOAD_MESSAGE.NONE,
        })),
      )
  }

  const getEans = id => {
    ProdutoHttp.getEans(id)
      .then(eans =>
        setState(prevState => ({ ...prevState, eans: eans, loadingMessage: LOAD_MESSAGE.NONE })),
      )
      .catch(err =>
        setState(prevState => ({
          ...prevState,
          errorMessage: errorHandler(err),
          loadingMessage: LOAD_MESSAGE.NONE,
        })),
      )
  }

  const onInit = data => {
    const { id, product_code, name } = data
    setState(prevState => ({
      ...prevState,
      id,
      product_code,
      name,
      codigoBarra: { ean: '', product_id: id, qte_caixa: '', packaging_type: '' },
      loadingMessage: LOAD_MESSAGE.GET,
    }))
  }

  const onFieldChange = (field, value) => {
    setState(prevState => {
      prevState.codigoBarra[field] = value
      return { ...prevState }
    })
  }

  const onBtnSalvarClicked = () => {
    setState(prevState => ({ ...prevState, loadingMessage: LOAD_MESSAGE.SAVE }))
  }

  const onBtnDeleteClicked = ean => {
    setState(prevState => ({ ...prevState, selectedEan: ean, loadingMessage: LOAD_MESSAGE.DELETE }))
  }

  const onBtnImprimirClicked = () => {
    window.location.href = urlCodigoBarrasEans(state.eans.map(e => e.ean))
  }

  const onSelecionarTodosClick = () => {
    setState(prevState => {
      prevState.selecionarTodos = !prevState.selecionarTodos
      prevState.eans.forEach(e => (e.selected = prevState.selecionarTodos))
      return { ...prevState }
    })
  }

  const formatCriadoEm = value => {
    if (typeof value !== 'string' || !value) return ''
    const date = formatIsoDateToLocale(value)
    return date.isValid ? date.toFormat('dd/MM/yyyy HH:mm:ss') : ''
  }

  const onItemClick = ean => {
    setState(prevState => {
      const index = prevState.eans.findIndex(c => c.id === ean.id)
      if (index !== -1) {
        const _eans = [...prevState.eans]
        _eans[index].selected = _eans[index].selected !== true
        prevState.eans = [..._eans]
      }
      return { ...prevState }
    })
  }

  return (
    <CustomModal
      header={`EAN : ${state.product_code} - ${state.name}`}
      isVisible={show}
      onClose={onModalClose}
      style={{ maxWidth: 700, width: '90%' }}
    >
      <form className="p-grid" onSubmit={e => e.preventDefault()}>
        <div className="p-col-12 p-md-6">
          <InputText
            marginTop={0}
            label="Novo Código de Barra"
            value={state.codigoBarra.ean}
            onChange={value => onFieldChange('ean', value)}
          />
        </div>
        <div className="p-col-12 p-md-3">
          <InputText
            marginTop={0}
            label="Quant. Caixas Por Bip"
            value={state.codigoBarra.qte_caixa}
            onChange={value => onFieldChange('qte_caixa', value)}
          />
        </div>
        <div className="p-col-12 p-md-3">
          {/* Tipo da embalagem do código de barras (ex.: UN, PCT, CX_MASTER). Opcional. */}
          <InputText
            marginTop={0}
            label="Tipo Embalagem"
            value={state.codigoBarra.packaging_type}
            onChange={value => onFieldChange('packaging_type', value)}
          />
        </div>
        <div className="p-col-12">
          <Btn onClick={onBtnSalvarClicked}>Salvar</Btn>
          <HorizontalSpacer size={8} />
          <Btn onClick={onBtnImprimirClicked} disabled={!state.eans.some(e => e.selected)}>
            Imprimir
          </Btn>
        </div>
        <div className="p-col-12">
          <CustomCheckbox checked={state.selecionarTodos} onChange={onSelecionarTodosClick}>
            Selecionar Todos
          </CustomCheckbox>
        </div>
      </form>
      <div className="p-grid" style={{ marginTop: 10 }}>
        <div className="p-col-12">
          <DataTable value={state.eans} responsive={true}>
            <Column
              header="#"
              className="ean-info-column ean-info-column-w80 column-mobile-hidden"
              body={veiculo => (
                <CustomCheckbox
                  checked={veiculo.selected === true}
                  onChange={() => onItemClick(veiculo)}
                />
              )}
            />
            <Column field="ean" header="Ean" className="ean-info-column" />
            <Column
              field="qte_caixa"
              header="Cx Por Bip"
              className="ean-info-column ean-info-column-w100 column-mobile-hidden"
            />
            <Column
              field="packaging_type"
              header="Embalagem"
              className="ean-info-column ean-info-column-w100 column-mobile-hidden"
              body={ean => ean.packaging_type || '-'}
            />
            <Column
              field="created_at"
              header="Criado em"
              className="ean-info-column ean-info-column-w150 column-mobile-hidden"
              body={ean => formatCriadoEm(ean.created_at)}
            />
            <Column
              header=""
              body={ean => (
                <BtnIcon onClick={() => onBtnDeleteClicked(ean)}>
                  <FaRegTrashAlt color="red" size={18} />
                </BtnIcon>
              )}
              className="ean-info-column-w80"
            />
          </DataTable>
        </div>
      </div>
    </CustomModal>
  )
}

const mapStateToProps = ({ system: { selectedTp } }) => ({ selectedTp })
export default connect(mapStateToProps)(ModalEan)
